export const EVENT_SECTIONS = {
  generalEvent:'generalEvent',
  tickers:'tickers'
}
